/* eslint-disable no-undef */
import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/store/modules/user'
import auth from '@/store/modules/auth'
import app from '@/store/modules/app'
import popup from '@/store/modules/popup'
import countries from '@/store/modules/countries'
import competition from '@/store/modules/competition'
import competitionMechanic from '@/store/modules/competition-mechanic'
import template from '@/store/modules/template'
import attributesTypes from '@/store/modules/attributes-types'
import attributesOptions from '@/store/modules/attributes-options'
import settings from '@/store/modules/settings'
import workflow from '@/store/modules/workflow'
import tag from '@/store/modules/tag'
import overview from '@/store/modules/overview'
import createPersistedState from 'vuex-persistedstate'
import service from '@/store/modules/service'

Vue.use(Vuex)
export default new Vuex.Store({
  actions: {
    resetState({ dispatch }) {
      dispatch('app/resetStateData', {}, { root: true })
      dispatch('auth/resetStateData', {}, { root: true })
      dispatch('attributesTypes/resetStateData', {}, { root: true })
      dispatch('competitionMechanic/resetStateData', {}, { root: true })
      dispatch('countries/resetStateData', {}, { root: true })
      dispatch('settings/resetStateData', {}, { root: true })
      dispatch('template/resetStateData', {}, { root: true })
      dispatch('user/resetStateData', {}, { root: true })
    }
  },
  modules: {
    user,
    app,
    popup,
    countries,
    competition,
    competitionMechanic,
    template,
    attributesTypes,
    attributesOptions,
    settings,
    workflow,
    tag,
    auth,
    service,
    overview
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({
      paths: [
        'auth.sessionExpirationTime',
        'user.currentUser',
        'user.userList',
        'countries.countriesList',
        'competitionMechanic.mechanicsList',
        'template.currentTemplate',
        'template.searchParams',
        'attributesTypes.currentlyEditedAttribute',
        'settings.activeTab',
        'workflow.currentlyEditedWorkflow'
      ]
    })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js